import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { COLOR } from 'constant'
import { makeStyles } from '@mui/styles'
import { SvgCarretDownIcon } from 'components/common/LeftPanel/LeftPanel.styled'

export type YearDropdownProps = {
  yearList: { key: number; label: number }[]
  currentYear: number
  onClick: (item: number) => void
  width?: number
}
const useStyles = makeStyles({
  option: {
    fontSize: '15px !important',
    '&:hover': {
      backgroundColor: `${COLOR.TEXT} !important`,
    },
  },
})
export default function YearDropdown({ yearList, currentYear, onClick, width = 130 }: YearDropdownProps) {
  const handleChangeYear = (event: React.SyntheticEvent, value: any) => {
    if (value) {
      onClick(Number(value))
    }
  }
  const styles = useStyles()

  return (
    <div>
      <Autocomplete
        id='year-dropdown'
        popupIcon={<SvgCarretDownIcon iconColor={COLOR.CARRET} width='20px' height='20px' />}
        disablePortal
        size='small'
        classes={{
          option: styles.option,
        }}
        disableClearable
        sx={{
          mx: 0,
          my: 1,
          width: width,
          '& .MuiAutocomplete-inputRoot': {
            border: `1px solid ${COLOR.DARK}`,
            height: '32px !important',
            borderRadius: '30px !important',
            fontFamily: 'CircularStdBook !important',
            paddingTop: '3px !important',
            fontSize: '15px !important',
          },
          '& .MuiAutocomplete-popupIndicator': {
            transform: 'none',
            background: 'transparent',
            marginTop: '2px',
            '&:focus, &:active': {
              transform: 'rotate(90deg)',
              background: 'transparent',
            },
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
          '& .MuiAutocomplete-popupIndicatorOpen': {
            transform: 'rotate(90deg)',
          },
        }}
        value={currentYear}
        onChange={handleChangeYear}
        options={yearList.map((year) => year.label)}
        getOptionLabel={(option) => option.toString()} // Convert number to string
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
            }}
            value={currentYear}
          />
        )}
      />
    </div>
  )
}
